import { initI18n } from '@agos/shared'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './index.css'

initI18n()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('index.html is missing the #root mount point')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
